export default __webpack_public_path__ + "static/media/arrow-right-s-line1.1af2b79d.svg";